import axios from 'axios';
import Config from '../config';
import { Toast } from 'vant';
import store from "../store";

//请求超时时间
axios.defaults.timeout = Config.REQUEST_TIMEOUT;
axios.defaults.baseURL = Config.API_ADDRESS[Config.ENV];

//请求拦截
axios.interceptors.request.use(
  config => {
    if (config.url.indexOf('login/login') < 0) {
      let userInfo = localStorage.getItem('user_info');
      if (userInfo) {
        userInfo = JSON.parse(userInfo);
        if (userInfo.token) {
          if (config.data instanceof FormData) {
            config.data.append('sessionId', userInfo.token);
          } else {
            config.data.sessionId = userInfo.token;
          }
        }
      }
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截，判断token是否过期
axios.interceptors.response.use(
  response => {
    let { data } = response;
    if (data.code === 'token failure!') {
      localStorage.removeItem('token');
    } else {
      return Promise.resolve(response);
    }
  },
  error => {
    return Promise.reject(error);
  }
);

const doGet = (method, params = {}) => {
  return new Promise((resolve, reject) => {
    return axios({
      url: method,
      method: 'get',
      data: params,
      transformRequest: [
        function(data) {
          let ret = '';
          for (let key in data) {
            ret += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&';
          }
          return ret;
        },
      ],
    })
      .then(res => {
        res = res.data;
        if (res.hasOwnProperty('code') && '0000' === res.code) {
          resolve(res.data);
        } else {
          Toast.fail(res.msg);
          if (typeof reject === 'function') {
            reject(res);
          }
        }
      })
      .catch(function(error) {
        if (typeof reject === 'function') {
          reject(error);
        }
      });
  });
};

function checkDate(method) {
  let checkKeys = ['editCustomer', 'updateCustomer']
  let valid = !checkKeys.find(key => method.indexOf(key) !== -1)
  if (valid) {
    return true
  }
  if (store.state.userInfo) {
    const { entrySureTime } = store.state.userInfo
    const now = new Date().getTime()
    if (entrySureTime - now < 0) {
      return false
    }
  }
  return true
}

const doPost = (method, params = {}, header = {}) => {
  return new Promise((resolve, reject) => {
    if (!checkDate(method)) {
      console.log('时间已过期!禁止提交')
      Toast('已到达截至日期，您的操作不会录入到系统');
      return resolve({"msg":"操作成功","code":"0001"})
    }

    // let ld = Toast.loading({
    //   message: '加载中...',
    //   forbidClick: true,
    // });

    return axios({
      url: method,
      method: 'post',
      data: params,
      headers: Object.assign({ 'Content-Type': 'application/x-www-form-urlencoded' }, header),
      transformRequest: [
        function(data) {
          if (!(data instanceof FormData)) {
            let ret = '';
            for (let key in data) {
              ret += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&';
            }

            return ret;
          }
          return data;
        },
      ],
    })
      .then(res => {
        // ld.clear();

        res = res.data;
        if ((res.hasOwnProperty('code') && '0000' === res.code) || 'C0000' === res.code) {
          resolve(res.data);
        } else {
          if (res.code && res.code !== 'Z000') {
            Toast.fail(res.msg);
          }
          if (typeof reject === 'function') {
            reject(res);
          }
        }
      })
      .catch(function(error) {
        // ld.clear();

        if (typeof reject === 'function') {
          reject(error);
        }
      });
  });
};

const getByteLen = val => {
  let len = 0;
  for (let i = 0; i < val.length; i++) {
    let a = val.charAt(i);
    if (a.match(/[^\x00-\xff]/gi) != null) {
      len += 2;
    } else {
      len += 1;
    }
  }
  return len;
};

export default {
  doGet,
  doPost,
  getByteLen,
};
